import {
  GET_ALL_CLASSWORK_PERFORMANCE,
  GET_STUDENT_CLASSWORK_PERFORMANCE,
  GET_CLASSWORK_PERFORMANCE,
  GET_CLASSWORK_PERFORMANCE_BATCH,
} from "../constants/Type";

const initialState = {
  classworkPerformance: null,
  students: null,
  extra: null,
  loading: true,
  results: null,
  all: null,
};

const classworkPerformanceReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_CLASSWORK_PERFORMANCE:
      return {
        ...state,
        classworkPerformance: payload.data,
        extra: payload.extra,
        loading: false,
      };
    case GET_ALL_CLASSWORK_PERFORMANCE:
      return {
        ...state,
        all: payload.data,
        extra: payload.extra,
        loading: false,
      };
    case GET_CLASSWORK_PERFORMANCE_BATCH:
      return {
        ...state,
        results: payload.data,
        extra: payload.extra,
        loading: false,
      };
    case GET_STUDENT_CLASSWORK_PERFORMANCE:
      return {
        ...state,
        students: { ...payload.data },
        extra: { ...payload.extra },
        loading: false,
      };

    default:
      return state;
  }
};

export default classworkPerformanceReducer;
